import React from "react";
import { GROEPEN } from "./afsprakenUtils";
import { TEGEL, TEGEL_WIT, TEGEL_LABEL, TEGEL_ROOD, TEGEL_GETAL, getalKleur } from "@/components/rust/Rust";

const rood = (g, counts) => g.key === "telaat" && (counts[g.key] || 0) > 0;

export const CounterTiles = ({ counts, active, onToggle }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-3 mb-3 md:mb-4" data-testid="afspraken-tellers">
    {GROEPEN.map((g) => {
      const on = active === g.key;
      return (
        <button key={g.key} type="button" data-testid={`teller-${g.key}`} aria-pressed={on} onClick={() => onToggle(on ? null : g.key)}
          className={`text-left ${TEGEL} transition-[box-shadow,background-color] duration-150 ${rood(g, counts) ? TEGEL_ROOD : TEGEL_WIT} ${on ? "ring-2 ring-zinc-950" : "hover:shadow-sm"}`}>
          <div className="flex items-center justify-between">
            <span className={TEGEL_LABEL}>{g.label}</span>
            <span className={`h-1.5 w-1.5 rounded-full ${g.dot}`} />
          </div>
          <div data-testid={`teller-count-${g.key}`} className={`${TEGEL_GETAL} ${getalKleur(counts[g.key] || 0, rood(g, counts))}`}>{counts[g.key] || 0}</div>
        </button>
      );
    })}
  </div>
);
